<div class="content m-3">
  <ng-container>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link active" role="tab" data-bs-toggle="tab" href="#tabCustomer">
          <p class="d-block">Customer</p>
        </a>
      </li>
      @if (selectedCompany != undefined) {
        <li class="nav-item">
          <a class="nav-link" role="tab" data-bs-toggle="tab" href="#tabLeads">
            <p class="d-block">Leads</p>
          </a>
        </li>
      }
    </ul>

    <div class="tab-content">
      <div class="tab-pane active" role="tabpanel" id="tabCustomer">
        <h3 class="text-start" id="pageTitle" style="margin: 15px">Customer List</h3>
        @if (!sharedService.isFinance()) {
          <div>
            <button class="btn btn-primary float-end" (click)="openAddCustomerDialog()"><i class="fas fa-plus"></i> Add Customer</button>
          </div>
        }

        <div class="row">
          <div class="col">
            <mat-form-field>
              <mat-label>Filter</mat-label>
              <input matInput (keyup)="applyFilter($event)" placeholder="Enter searching criteria" />
            </mat-form-field>
          </div>
          <div class="col">
            <select class="browser-default form-select" [(ngModel)]="selectedStatus" (change)="filterByStatus()">
              <option></option>
              @for (status of enums.customerStatusString; track status; let i = $index) {
                <option [value]="i + 1">
                  {{ status }}
                </option>
              }
            </select>
          </div>
        </div>

        <div class="mat-elevation-z8">
          <table mat-table [dataSource]="dataSource" matSort>
            <!-- Name Column -->
            <ng-container matColumnDef="Name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
              <td mat-cell *matCellDef="let customer" (click)="goToCustomer(customer.ID)">
                @if (checkNewCustomer(customer) == true) {
                  <span class="badge text-bg-success">NEW </span>
                }
                {{ customer.Name }}
              </td>
            </ng-container>

            <!-- Occupation Column -->
            <!-- <ng-container matColumnDef="Occupation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Occupation </th>
          <td mat-cell *matCellDef="let customer" (click)="goToCustomer(customer.ID)">
          {{customer.Occupation}} </td>
        </ng-container> -->

            <!-- ICNumber Column -->
            <ng-container matColumnDef="ICNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>IC Number</th>
              <td mat-cell *matCellDef="let customer" (click)="goToCustomer(customer.ID)">
                {{ customer.ICNumberWithDash }}
              </td>
            </ng-container>

            <!-- Remark Column -->
            <!-- <ng-container matColumnDef="Remark">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Remark </th>
        <td mat-cell *matCellDef="let customer" (click)="goToCustomer(customer.ID)"> {{customer.Remark}} </td>
      </ng-container> -->

            <!-- Status Column -->
            <ng-container matColumnDef="Status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let customer">
                @for (status of customer.Status; track status) {
                  <h5 class="d-inline ms-1">
                    <span class="badge text-bg-primary" [ngClass]="getStatusColor(status.StatusCode)" (click)="showCustomerLoans(status.StatusCode, customer.ID)" container="body"
                      >{{ convertStatusString(status.StatusCode) }}
                      x
                      {{ status.Occurrence }}
                    </span>
                  </h5>
                }
              </td>
            </ng-container>

            <!-- Remark Column -->
            <ng-container matColumnDef="Remark">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Remark</th>
              <td mat-cell *matCellDef="let customer; let i = index">
                @if (customer.NeedAttention == undefined) {
                  <h3 class="d-inline ms-1" (click)="addCustomerRemark(customer.ID, i)">
                    <span class="badge text-bg-primary" style="cursor: pointer">
                      <i class="fas fa-comment-medical"></i>
                    </span>
                  </h3>
                }

                @if (customer.NeedAttention == false) {
                  <h3 class="d-inline ms-1" (click)="viewCustomerRemark(customer.ID, customer.Name)">
                    <span class="badge text-bg-warning" style="cursor: pointer">
                      <i class="far fa-comment"></i>
                    </span>
                  </h3>
                }

                @if (customer.NeedAttention == true) {
                  <h3 class="d-inline ms-1" (click)="viewCustomerRemark(customer.ID, customer.Name)">
                    <span class="badge text-bg-danger" style="cursor: pointer">
                      <i class="fas fa-exclamation-circle"></i>
                    </span>
                  </h3>
                }
              </td>
            </ng-container>

            <!-- Action Column -->
            <ng-container matColumnDef="Action">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
              <td mat-cell *matCellDef="let customer">
                <button class="btn btn-info" (click)="viewCustomerImages(customer)" #tooltip="matTooltip" matTooltip="View Customer Docs" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black"><i class="fas fa-images"></i></button>

                @if (customer.Verified == false && !sharedService.isFinance()) {
                  <button class="btn btn-success ms-1" (click)="confirmBeforeVerifyCustomer(true, customer.ID)" #tooltip="matTooltip" matTooltip="Verify Customer" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black" [hidden]="sharedService.isAuditor() == true">
                    <i class="fas fa-user-check"></i>
                  </button>
                }

                @if (customer.Verified == true && !sharedService.isFinance()) {
                  <button class="btn btn-dark ms-1" (click)="confirmBeforeVerifyCustomer(false, customer.ID)" #tooltip="matTooltip" matTooltip="Unverify Customer" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black" [hidden]="sharedService.isAuditor() == true">
                    <i class="fas fa-user-times"></i>
                  </button>
                }
                @if (customer.Verified == true && !sharedService.isFinance()) {
                  <span class="badge text-bg-success ms-1" style="font-size: 0.9rem"
                    >Verified by
                    {{ customer.VerifiedBy || "-" }}
                  </span>
                }
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>

          <mat-paginator [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons></mat-paginator>
        </div>
      </div>
      @if (selectedCompany != undefined) {
        <div class="tab-pane" role="tabpanel" id="tabLeads">
          <app-customer-lead-list></app-customer-lead-list>
        </div>
      }
    </div>
  </ng-container>
</div>

<!--POPOVER CUSTOMER LOAN LIST FILTER BY STATUS-->
<ng-template #popContent let-modal>
  <div class="p-4">
    <div class="card mb-2">
      <div class="card-body">
        <b>{{ selectedCustomer.Name }} ({{ selectedCustomer.ICNumberWithDash }})</b>
      </div>
    </div>
    @for (loan of customerLoansList; track loan.ID) {
      <app-loan-card [loan]="loan" [isSimplifiedView]="true"></app-loan-card>
    }
  </div>
</ng-template>

<ng-template #customerDetails let-data>
    <div class="fw-bold mb-2">
      <div>{{ data.name }}</div>
      <div>{{ data.ic }} | {{ data.dob | date: "dd-MM-yyyy" }}</div>
    </div>
</ng-template>